module.exports = __webpack_public_path__ + "static/media/blog-gear3.0b22ea61.jpg";